<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Navigation -->
<fuse-vertical-navigation
    class="dark bg-gray-900 print:hidden"
    [mode]="isScreenSmall ? 'over' : 'side'"
    [autoCollapse]="false"
    [name]="'mainNavigation'"
    [navigation]="navigation.default"
    [opened]="!isScreenSmall">
    <!-- Navigation header hook -->
    <ng-container fuseVerticalNavigationContentHeader>
        <!-- Logo -->
        <div class="flex justify-center h-34 p-4" [ngClass]="{ 'bg-yellow-400': !isProd, 'bg-accent': isProd, 'mb-4': isProd }">
            <img class="w-44" src="assets/images/logo/tecsa_logo_nuevo.png" alt="Logo image">
        </div>
        <div class="flex justify-center p-2 bg-yellow-800 mb-4" *ngIf="!isProd">Estás en ambiente de pruebas</div>
    </ng-container>
    <ng-container fuseVerticalNavigationFooter>
        <!-- Footer -->
        <div class="relative flex flex-0 items-center justify-start w-full p-4 z-49 bg-card border-t">
            <span class="font-medium text-secondary">Grupo Tecnología Educativa &copy; {{currentYear}}</span>
        </div>
    </ng-container>
</fuse-vertical-navigation>

<!-- Wrapper -->
<div class="flex flex-col flex-auto w-full min-w-0">

    <!-- Header -->
    <div class="relative flex flex-0 items-center w-full h-16 px-4 md:px-6 z-49 shadow dark:shadow-none dark:border-b bg-card dark:bg-transparent print:hidden">
        <!-- Navigation toggle button -->
        <button
            mat-icon-button
            (click)="toggleNavigation('mainNavigation')">
            <mat-icon [svgIcon]="'heroicons_outline:menu'"></mat-icon>
        </button>
        <!-- Components -->
        <div class="flex items-center pl-2 ml-auto space-x-0.5 sm:space-x-2">
            <!-- <languages></languages> -->
            <fuse-fullscreen class="hidden md:block"></fuse-fullscreen>
            <!-- <search [appearance]="'bar'"></search> -->
            <!-- <shortcuts></shortcuts> -->
            <!-- <messages></messages> -->
            <button
                mat-icon-button
                (click)="changeScheme(config.scheme === 'dark' ? 'light' : 'dark')">
                <mat-icon [svgIcon]="config.scheme === 'dark' ? 'heroicons_outline:moon' : 'heroicons_outline:sun'"></mat-icon>
            </button>
            <notifications></notifications>

            <user></user>
        </div>
    </div>

    <!-- Content -->
    <div class="flex flex-col flex-auto">
        <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
             Otherwise, layout changes won't be registered and the view won't be updated! -->
        <router-outlet *ngIf="true"></router-outlet>
    </div>

    <!-- Footer -->
    <!-- <div class="relative flex flex-0 items-center justify-start w-full h-14 px-4 md:px-6 z-49 border-t bg-card dark:bg-transparent print:hidden">
        <span class="font-medium text-secondary">Grupo Tecnología Educativa &copy; {{currentYear}}</span>
    </div> -->

</div>

<!-- Quick chat -->
<!-- <quick-chat #quickChat="quickChat"></quick-chat> -->
